<div [formGroup]="form" class="list__item-container">
  <div class="list__item-img">
    <img
      [alt]="accessory.title"
      [src]="accessory.imgUrl"
      onerror="this.src='assets/images/fallback.png'"
    >
  </div>

  <div class="list__item-content">
    <div class="list__item-info">
      <h3 class="card__title">{{accessory.title}}</h3>
      <p class="price">
        <span class="euro">€</span>
        <span class="price">
        {{getPriceForAccessory()}}
      </span>
      </p>
    </div>

    <div *ngIf="product && product.variations && availableColorProperties?.length > 0">

      <p class="option__info">{{ 'products.product-info-modal.choose-variation' | translate }}</p>
      <div class="option__colors option__colors--fixed-width">
        <label
          *ngFor="let colorProperty of availableColorProperties"
          class="configurator__color-chooser option__colors-chooser"
          [for]="'accessory-color-' + idForSelectedColorProperty + '-' + colorProperty.id">
          <input
            [formControlName]="idForSelectedColorProperty"
            [value]="colorProperty.id"
            [id]="'accessory-color-' + idForSelectedColorProperty + '-' + colorProperty.id"
            type="radio">
          <div class="color__container">
            <div
              [style]="{'background': colorProperty.image ? 'url('+colorProperty.image+')' : colorProperty.hex}">
            </div>
            <div class="color__check">
            <span class="material-symbols-outlined">
              check
            </span>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div *ngIf="product && product.variations && accessory.widthVariations?.length > 0">
      <p class="option__info">{{ 'products.product-info-modal.choose-width-variation' | translate }}</p>
      <div class="option__colors">
        <div class="option__container">
          <label
            *ngFor="let variation of accessory.widthVariations"
            [for]="'accessory-width-' + idForSelectedWidth + '-' + variation.width"
            class="option__label option__label--card">
            <input
              [id]="'accessory-width-' + idForSelectedWidth + '-' + variation.width"
              [value]="variation.width"
              [formControlName]="idForSelectedWidth"
              type="radio">
            <div class="label__container">

              <div class="option__title__container">
                <span class="option__title mr-2">{{ variation.width.split('-')[2] }}</span>
                <span class="material-symbols-outlined option--selected">
                check_circle
              </span>
                <span class="material-symbols-outlined option--not-selected">
                radio_button_unchecked
              </span>
              </div>
            </div>
          </label>
        </div>

      </div>
    </div>

    <div *ngIf="product && product.variations && accessory.sideVariations?.length > 0">
      <p class="option__info">{{ 'products.product-info-modal.choose-side-variation' | translate }}</p>
      <div class="option__colors">
        <div class="option__container">
          <label
            *ngFor="let variation of accessory.sideVariations"
            [for]="'accessory-side-' + idForSelectedSide + '-' + variation.side"
            class="option__label option__label--card">
            <input
              [id]="'accessory-side-' + idForSelectedSide + '-' + variation.side"
              [value]="variation.side"
              [formControlName]="idForSelectedSide"
              type="radio">
            <div class="label__container">

              <div class="option__title__container">
                <span class="option__title mr-2">{{ variation.side }}</span>
                <span class="material-symbols-outlined option--selected">
                check_circle
              </span>
                <span class="material-symbols-outlined option--not-selected">
                radio_button_unchecked
              </span>
              </div>
            </div>
          </label>
        </div>

      </div>
    </div>

    <div class="list__item-buttons">
      <button (click)="removeAccessory()" [disabled]="removeButtonIsDisabled()"
              class="button button--icon button--primary"
              type="button">
      <span class="material-symbols-outlined">
        remove
      </span>
      </button>

      <input
        [formControlName]="accessory.id + '-number'"
        class="input--number"
        type="number">

      <button (click)="addAccessory()" class="button button--icon button--primary" type="button">
      <span class="material-symbols-outlined">
        add
      </span>
      </button>
    </div>
  </div>

</div>
